/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ProductUpdateToastNotification.tsx
 *
 * Project Title :  Checkout
 *
 * Description	 : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date		: Oct 10 2020
 *
 * @Version      : Version 1.0
 *
*******************************************************************************/


import * as  React from 'react';
import { Notification } from '@scuf/common';
import { CheckoutUILabels } from '../constants/checkout-constants';
import { ContactUsMessage } from '../Common/ContactUsMessage';

interface IUpdateToast {
    productCtg: string;
    closeToast: any;
    success: boolean;
}

function ProductUpdateToastNotification(props: IUpdateToast) {
    return (
        <React.Fragment>
            {props.success ?
                <Notification
                    className="toast-notification"
                    hasIcon={true}
                    title={CheckoutUILabels.UPDATE_TO_CART_SUCCESS_HEADING}
                    severity="success"
                    detailsText="CHECKOUT"
                    onCloseClick={props.closeToast}
                >
                {props.productCtg + CheckoutUILabels.UPDATE_TO_CART_SUCCESS_MSG }
                </Notification> :
                <Notification
                    hasIcon={true}
                    title={'unable to update' + props.productCtg + ' in your cart.'}
                    severity="critical"
                >
                    <ContactUsMessage>Please try again. {CheckoutUILabels.IF_ISSUE_PERSISTS}</ContactUsMessage>
                </Notification>
            }
            </React.Fragment>
    );
}

export default ProductUpdateToastNotification;